import { Slide } from 'react-awesome-reveal';
import { Box, Stack, Typography } from '@mui/material';
import { Fade } from 'react-awesome-reveal';
import { Section1 } from './componenets/Section1';
import Footer from '../footer/FooterSection';
import Navbar from '../navbar/Navbar';
import sectionConstants from '../constants/SectionConstants';
import './TermsCondtions.scss';

export const TermsCondtions = () => {
  return (
    <Box className='terms-condtion-page'>
      <Box id='top' className='terms-condtion-image'>
        <Box>
          <Navbar />
        </Box>
        <Stack className='terms-condtion-heading' spacing={2}>
          <Typography className='terms-condtion-heading-data1'>
            <Slide>{sectionConstants.TermsConditions}</Slide>
          </Typography>
        </Stack>
      </Box>
      <Section1 />
      <Footer />
    </Box>
  );
};
